/**
 * Copies the text to the clipboard. The Clipboard API only exists in secure contexts (https, localhost),
 * so on a plain http deployment it falls back to selecting the text in a hidden textarea.
 *
 * @return {Promise<boolean>} whether the text was copied
 */
export async function copyText(text) {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (e) {
            // Permission denied: try the fallback below
        }
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
        return document.execCommand('copy');
    } catch (e) {
        return false;
    } finally {
        document.body.removeChild(textarea);
    }
}
